export default "__VITE_ASSET__DdI5p0$j__"